<template>
  <div class="login-main">
    <nav-bar></nav-bar>
    <section class="orders-status-start">
      <div
        class="review-container review-main text-capitalize position-relative"
      >
        <div class="row">
          <div class="col-md-12 p-0" v-if="loadIframe">
            <div class="row">
              <staticiframe
                :iframeurl="iframeLink"
                :pageName="staticPageName"
                v-on:displaypages="setStaticPages"
              ></staticiframe>
            </div>
          </div>
          <div class="col-md-12" v-else>
            <div class="ref-top-section refCdeSec pt-2 pb-5 pr-2">
              <div class="plr15 text-right pt-1 pb-2">
                <a
                  href="javascript:void(0)"
                  @click="
                    loadIframeAction(
                      $auth.setting.referral_terms_and_conditions,
                      'Referral Terms & Conditions'
                    )
                  "
                  >{{ $t("Terms & conditions") }}</a
                >
              </div>
              <div class="plr15">
                <h4 class="text-left">
                  Earn
                  <span v-html="$auth.setting.currency" class="currency"></span
                  >{{ $auth.setting.referral_amount }} each
                </h4>
                <p>{{ $auth.setting.referral_description }}</p>
              </div>
              <div class="bottom-img">
                <img src="@/assets/images/referral.png" />
              </div>
            </div>
            <div class="orders-tab-main copy-sec">
              <div class="content pt-4">
                <div class="coupon-wrapper">
                  <input
                    class="coupon-input"
                    readonly="true"
                    id="select-coupon"
                    :value="$auth.user.referral_code"
                  />
                  <button
                    class="coupon-button"
                    id="clickCoupon"
                    @click="doCopy($auth.user.referral_code)"
                  >
                    Copy
                  </button>
                </div>
              </div>
              <!-- <span class="or-tag pt-4">OR</span>
              <div class="share-itm or-tag share pt-4 share-btn">
                <button class="social-media-btn"><i class="fab fa-whatsapp"  @click="shareClick"></i></button>
                <button class="social-media-btn"><i class="fab fa-skype"  @click="shareClick"></i></button>                
                <button class="social-media-btn"><i class="fab fa-facebook-f"  @click="shareClick"></i></button>
              </div> -->
              <!-- <span class="or-tag share pt-4 share-btn" @click="shareClick"><i class="fa fa-share-alt" aria-hidden="true"></i></span> -->
            </div>
            <div class="referral_terms plr15 mt-4">
              <h4>How it works?</h4>
              <p class="work-txt">{{ $auth.setting.referral_terms }}</p>
            </div>
          </div>
        </div>
      </div>
      <Footer></Footer>
    </section>
  </div>
</template>
<script>
import NavBar from "@/components/NavBar.vue";
import Footer from "../components/Footer.vue";
import staticiframe from "../components/StaticIframe.vue";
export default {
  components: {
    NavBar,
    Footer,
    staticiframe,
  },
  data() {
    return {
      loadIframe: false,
      iframeLink: "",
      staticPageName: "",
    };
  },
  mounted() {},
  methods: {
    loadIframeAction(url, name) {
      this.loadIframe = true;
      this.iframeLink = url;
      this.staticPageName = name;
    },
    setStaticPages() {
      this.loadIframe = false;
    },
    doCopy(el) {
      this.isSelectCoupon = el;
      this.$copyText(el).then(function (e) {
        navigator.clipboard.writeText(e.text);
      });
      this.$toasted.success(this.$t("Referral Code Copied to clipboard."), {
        duration: 2000,
      });
    },
  },
};
</script>
<style scoped>
p.work-txt {
  color: #ada7a7;
}
.review-container {
  padding: 70px 0 90px 0 !important;
  min-height: 93.5vh !important;
}
.refCdeSec {
  background-color: rgba(var(--theme-primary));
  color: white;
  position: relative;
}
.refCdeSec a {
  color: white;
  position: relative;
  z-index: 9;
}
.refCdeSec .bottom-img {
  position: absolute;
  bottom: 0;
  right: 0;
  font-size: 14px;
}
.copy-sec {
  background-color: #ffffff;
  border-top-left-radius: 8px;
  margin-top: -5px;
  position: relative;
  border-top-right-radius: 8px;
}

.refCdeSec .bottom-img img {
  width: 110px;
}
.content {
  width: 68%;
  margin: auto;
}
.share-itm {
  text-align: center;
}

.coupon-wrapper {
  height: auto;
  background-color: #f7f7f7;
  align-items: center;
  display: flex;
  border-radius: 37px;
  font-size: 20px;
  border: 3px dotted rgba(var(--theme-primary));
}

.coupon-input {
  border: 0;
  margin-right: -20px;
  background-color: #f7f7f7;
  border-radius: 37px;
  max-width: 150px;
  text-align: center;
  outline: none;
}
.coupon-input::-moz-selection {
  background: none;
}
.coupon-input::selection {
  background: none;
}
.coupon-input::-moz-selection {
  background: none;
}
.coupon-input::-webkit-selection {
  background: none;
}

.coupon-button {
  border: 0;
  color: #fff;
  display: inline-block;
  position: relative;
  transition: all 300ms ease;
  background-color: rgba(var(--theme-primary));
  border-radius: 30px;
  padding: 15px 35px;
  margin: 6px;
  outline: none;
  margin-left: auto;
}
.coupon-button:hover {
  background-color: rgba(var(--theme-primary));
}
span.or-tag {
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  position: relative;
  z-index: 9;
}
span.share {
  color: red;
  font-size: 27px;
}
.referral_terms {
  padding: 20px;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
}
.social-media {
  /* opacity: 0; */
  transition: 0.5s;
  transition-delay: 0s;
  width: 250px;
  height: 120px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin: 10px 0;
}

.social-media-btn {
  border: none;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: #000;
  color: green;
  line-height: 50px;
  font-size: 25px;
  cursor: pointer;
  margin: 0 5px;
  text-align: center;
}

.social-media-btn:nth-child(1),
.social-media-btn.fa-whatsapp {
  background: #ffffff;
  color: green;
}

.social-media-btn:nth-child(2),
.social-media-btn.fa-facebook {
  background: #ffffff;
  color: #00aff0;
}
.social-media-btn:nth-child(3),
.social-media-btn.fa-facebook {
  background: #ffffff;
  color: #3b5998;
}
.share-options {
  position: absolute;
  bottom: 35%;
  left: 50%;
  width: auto;
  height: auto;
  transform-origin: bottom left;
  transform: scale(0);
  border-top-left-radius: 20px;
  border-bottom-right-radius: 20px;
  background: rgba(15, 15, 15, 0.5);
  color: #fff;
  padding: 20px;
  font-family: "roboto";
  transition: 0.5s;
  transition-delay: 0.5s;
}

.share-options.active {
  transform: scale(1);
  transition-delay: 0s;
}
</style>
